<script>
export default {
    name: 'IconSortUp'
}
</script>
<template>
    <svg
        class="base-icon icon-sort-up"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M22 8l.248 39.387 6.564-6.563L32 44 20 56 8 44l3.188-3.176 6.56 6.56L17.5 8H22zm18 24v6h-8v-6h8zm8-12v6H32v-6h16zm8-12v6H32V8h24z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
